import { Phone } from "lucide-react";

export const WHATSAPP_NUMBER = "916290074471";
export const WHATSAPP_NUMBER_DISPLAY = "+91 62900 74471";
export const whatsAppLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
export const WHATSAPP_LINK = whatsAppLink("Hi Solve Desk! I'm interested in a virtual office. Please share details.");
export const CALL_LINK = `tel:+${WHATSAPP_NUMBER}`;

export function WhatsAppIcon({ className = "w-6 h-6" }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.297-.497.1-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  );
}

export default function WhatsAppButton() {
  return (
    <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer"
      data-testid="whatsapp-float-button" aria-label="Chat with Solve Desk on WhatsApp"
      className="fixed bottom-6 right-6 z-50 group hidden md:block">
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" aria-hidden="true" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_8px_24px_rgb(37,211,102,0.4)] transition-transform duration-200 group-hover:scale-110">
        <WhatsAppIcon className="w-7 h-7" />
      </span>
      <span className="absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-slate-900 text-white text-xs font-medium px-3.5 py-1.5 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
        Chat on WhatsApp
      </span>
    </a>
  );
}

export function MobileQuickBar() {
  return (
    <div className="fixed bottom-0 inset-x-0 z-50 md:hidden bg-white/95 backdrop-blur-xl border-t border-black/10 shadow-[0_-4px_20px_rgb(0,0,0,0.08)]" data-testid="mobile-quick-bar">
      <div className="grid grid-cols-2 gap-3 p-3">
        <a href={CALL_LINK} data-testid="quickbar-call-button"
          className="flex items-center justify-center gap-2 h-12 rounded-full bg-slate-900 text-white text-sm font-semibold active:scale-95 transition-transform duration-150">
          <Phone className="w-4 h-4" /> Call Now
        </a>
        <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" data-testid="quickbar-whatsapp-button"
          className="flex items-center justify-center gap-2 h-12 rounded-full bg-[#25D366] text-white text-sm font-semibold active:scale-95 transition-transform duration-150">
          <WhatsAppIcon className="w-5 h-5" /> WhatsApp
        </a>
      </div>
    </div>
  );
}
